const SideNavSections = [
  { key: 'program', title: 'Program', items: [
    { name: 'Nadzorna ploča', code:"dash", icon: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z' },
    { name: 'Operateri', code:"oper",icon: 'M16 21v-2a4 4 0 0 0-3-3.87M8 21v-2a4 4 0 0 1 3-3.87M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z' },
    { name: 'Knjige',code:"knjg",icon: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' },
    { name: 'Postavke',code:"dash",icon: 'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6' },
  ]},
  { key: 'sifarnici', title: 'Šifarnici', items: [
    { name: 'Osobe',code:"osobe",icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' },
    { name: 'Lokacije', code:"lokacije", icon: 'M12 21s-6-5.686-6-10a6 6 0 1 1 12 0c0 4.314-6 10-6 10zM12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' },
    { name: 'Klaonice', code:"klaonice", icon: 'M3 21V7l9-4 9 4v14M3 21h18M9 21v-6h6v6' },
    { name: 'Države',   code:"drzave", icon: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z' },
    { name: 'Pasmine',  code:"pasmine", icon: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01' },
  ]},
  { key: 'registar', title: 'Registar', items: [
    { name: 'Registar', code:"registar", icon: 'M9 4h6a2 2 0 0 1 2 2H7a2 2 0 0 1 2-2zM7 6H5v15h14V6h-2M9 12h6M9 16h6' },
    { name: 'Dolasci',  code:"dolasci", icon: 'M12 3v12M7 10l5 5 5-5M5 21h14' },
    { name: 'Odlasci',  code:"odlasci", icon: 'M12 21V9M7 14l5-5 5 5M5 3h14' },
    { name: 'Izlučenja',code:"izlucenja", icon: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM8 12h8' },
    { name: 'Popisi goveda', code:"popisi", icon: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01' },
    { name: 'Specifikacije', code:"specifikacije", icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5' },
    { name: 'Putnice (OCR)', code:"govscan", icon: 'M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M7 12h10' },
  ]},
];


export {SideNavSections};